// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import drf from "./drf";
import { APIError } from "./errors";
import config from "config";
import merge from "lodash/merge";
import pick from "lodash/pick";

const defaultSettings = {
  basePath: "api",
  domain: config.get("apiDomain"),
  hasMultipleQueryParamValues: false,
  headers: {},
  returnCookies: false,
  scheme: config.get("apiScheme"),
  trailingSlash: true,
  useHeaderPagination: false,
};

const mergeSettings = (oldSettings, newSettings) => {
  newSettings = pick(newSettings, Object.keys(defaultSettings));

  return merge({}, oldSettings, newSettings);
};

// This is so low level that we can't really define useful types
export type ApiType = {
  reset: () => void;
  configure: (settings: any) => void;
  setDomain: (newDomain: string) => any;
  get: (
    resource: any,
    overrides?: any,
    params?: any,
    casingIgnorePaths?: any,
  ) => any;
  patch: (
    resource: any,
    overrides?: any,
    data: any,
    casingIgnorePaths?: any,
  ) => any;
  post: (
    resource: any,
    overrides?: any,
    data: any,
    casingIgnorePaths?: any,
  ) => any;
  postText: (
    resource: any,
    overrides?: any,
    data: any,
    casingIgnorePaths?: any,
  ) => any;
  put: (
    resource: any,
    overrides?: any,
    data: any,
    casingIgnorePaths?: any,
  ) => any;
  delete: (
    resource: any,
    data?: any,
    overrides?: any,
    casingIgnorePaths?: any,
  ) => any;
  url: (path: string) => any;
};

class API {
  constructor() {
    this.reset();
    this.backend = drf;
  }

  reset() {
    this.settings = defaultSettings;
  }

  configure(settings) {
    this.settings = mergeSettings(this.settings, settings);
  }

  setDomain(domain) {
    const headerName = config.get("sitesDomainRequestHeader");

    this.configure({
      headers: {
        [headerName]: domain,
      },
    });
  }

  get(resource, overrides, params, casingIgnorePaths) {
    const settings = mergeSettings(this.settings, overrides);

    return this.backend.get(resource, params, settings, casingIgnorePaths);
  }

  patch(resource, overrides, data, casingIgnorePaths) {
    const settings = mergeSettings(this.settings, overrides);

    return this.backend.patch(resource, data, settings, casingIgnorePaths);
  }

  post(resource, overrides, data, casingIgnorePaths) {
    const settings = mergeSettings(this.settings, overrides);

    return this.backend.post(resource, data, settings, casingIgnorePaths);
  }

  postText(resource, overrides, data, casingIgnorePaths) {
    const settings = mergeSettings(this.settings, overrides);

    return this.backend.postText(resource, data, settings, casingIgnorePaths);
  }

  put(resource, overrides, data, casingIgnorePaths) {
    const settings = mergeSettings(this.settings, overrides);

    return this.backend.put(resource, data, settings, casingIgnorePaths);
  }

  delete(resource, data, overrides, casingIgnorePaths) {
    const settings = mergeSettings(this.settings, overrides);

    return this.backend.delete(resource, data, settings, casingIgnorePaths);
  }

  options(resource) {
    return this.backend.options(resource, this.settings);
  }

  url(resource, overrides, params) {
    const settings = mergeSettings(this.settings, overrides);

    return this.backend.makeUrl(resource, params, settings);
  }
}

const apiConfig = {
  domain: config.get("apiDomain"),
  scheme: config.get("apiScheme"),
};

export default new API() as ApiType;
export { API, apiConfig, APIError };
